import { IPostingType } from '../interfaces/interfaces/posting-type.query.interface';
import { IPostingTypeDTO } from '../interfaces/dto/posting-type.dto.interface';

export class PostingType {
    id: string;
    name: string;
    enabledFor: {
        normal: boolean;
        article: boolean;
        courseCategory: boolean;
        courseOffering: boolean;
    };
    displayNameKeySingular: string;
    displayNameKeyPlural: string;
    actionButtonTextKey: string;

    constructor(postingQuery?: IPostingType, iPostingTypeDTO?: IPostingTypeDTO) {
        if (postingQuery) {
            this.id = postingQuery.id;
            this.name = postingQuery.name;
            this.displayNameKeySingular = postingQuery.display_name_key_singular;
            this.displayNameKeyPlural = postingQuery.display_name_key_plural;
            this.actionButtonTextKey = postingQuery.action_button_text_key;
            this.enabledFor = postingQuery.enabled_for
                ? {
                      normal: postingQuery.enabled_for.normal,
                      article: postingQuery.enabled_for.article,
                      courseCategory: postingQuery.enabled_for.course_category,
                      courseOffering: postingQuery.enabled_for.course_offering,
                  }
                : null;
        }
        if (iPostingTypeDTO) {
            this.id = iPostingTypeDTO.id;
            this.name = iPostingTypeDTO.name;
            this.displayNameKeySingular = iPostingTypeDTO.displayNameKeySingular;
            this.displayNameKeyPlural = iPostingTypeDTO.displayNameKeyPlural;
            this.actionButtonTextKey = iPostingTypeDTO.actionButtonTextKey;
            this.enabledFor = iPostingTypeDTO.enabledFor
                ? {
                      normal: iPostingTypeDTO.enabledFor.normal,
                      article: iPostingTypeDTO.enabledFor.article,
                      courseCategory: iPostingTypeDTO.enabledFor.courseCategory,
                      courseOffering: iPostingTypeDTO.enabledFor.courseOffering,
                  }
                : null;
        }
    }
}
